import WindPlot from "../wind";
import WeatherPlot from "../weather";
import { getStationData } from "../util";
import Box from "@mui/material/Box";


export default function Maggiore ({ forecast }) {

  // Get forecast for this station
  let [vmax, speed, dir, t2m, precip, dursun, twater, qff] = getStationData(forecast, "CAN", "maggiore", "QFF_KLO_GVE");

  return (
    <div>
      <title>Lago Maggiore Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Lago Maggiore</h2>
          <h3>Cannobio</h3>
          <Box sx={{ overflow: "auto" }}>
            <WindPlot vmax={vmax} speed={speed} dir={dir} />
            <WeatherPlot t2m={t2m} precip={precip} sun={dursun} twater={twater} />
          </Box>
        </div>
      </div>
    </div>
  );
};
